<div class="card">
  <div class="card-action-overlay" (click)="handlePreviewClicked(this.email)"></div>
  <div class="card-image-container">
    <ng-container *ngIf="email.previewUrl; else emailTemplate">
      <img src="{{ email.previewUrl }}" alt="preview" />
    </ng-container>
    <ng-template #emailTemplate>
      <div class="iframe-container">
        <div class="disable-iframe"></div>
        <iframe
          sandbox="allow-same-origin allow-popups allow-popups-to-escape-sandbox"
          [srcdoc]="email.templateHtml | iTrustThisHtml"
        ></iframe>
      </div>
    </ng-template>
  </div>
  <div class="card-content">
    <div class="card-content-info">
      <div class="card-content-info-title">
        {{ email.title }}
      </div>
      <div *ngIf="defaultAction !== DefaultCardAction.DUPLICATE" class="card-content-info-subtitle">
        <ng-container *ngIf="email.updated <= email.created">
          {{ 'EMAIL_LIBRARY.CARD.CREATED' | translate }}
        </ng-container>
        <ng-container *ngIf="email.updated > email.created">
          {{ 'EMAIL_LIBRARY.CARD.UPDATED' | translate }}
        </ng-container>
        {{ email.updated.toLocaleDateString('en-US', dateOptions) }}
      </div>
    </div>

    <ng-container *ngIf="!readOnly">
      <div class="card-content-actions">
        <button mat-icon-button class="card-content-actions-button" [matMenuTriggerFor]="templateActionsMenu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu #templateActionsMenu="matMenu">
          <button mat-menu-item (click)="handlePreviewClicked(email)">
            {{ 'COMMON.ACTION_LABELS.PREVIEW' | translate }}
          </button>
          <button *ngIf="defaultAction !== DefaultCardAction.DUPLICATE" mat-menu-item [routerLink]="[email.editorUrl]">
            {{ 'COMMON.ACTION_LABELS.EDIT' | translate }}
          </button>
          <button mat-menu-item (click)="handleDuplicateClicked(email)">
            {{ 'COMMON.ACTION_LABELS.DUPLICATE' | translate }}
          </button>
          <button
            *ngIf="defaultAction !== DefaultCardAction.DUPLICATE"
            mat-menu-item
            (click)="handleDeleteClicked(email)"
          >
            {{ 'COMMON.ACTION_LABELS.DELETE' | translate }}
          </button>
        </mat-menu>
      </div>
    </ng-container>
  </div>
</div>
